<!-- <header>
    <a routerLink="/about/announcement">TYT Announcements</a>
</header> -->
<div class="todays-live-container">
  <app-spinner *ngIf="!upcomingEvents"></app-spinner>
  <ul *ngIf="upcomingEvents">
    <li [class.next-day]="i >= todayCount" *ngFor="let liveSchedule of limitArray(upcomingEvents, 8); index as i">
      <div *ngIf="liveSchedule.show" class="image-container">
        <responsive-picture [src]="liveSchedule.show.logo_square" [width]="32"></responsive-picture>
      </div>
      <div class="addendum">
        <a *ngIf="getEventStream(liveSchedule)" class="title"
          routerLink="/live/streams/{{getEventStream(liveSchedule).id}}">{{liveSchedule.title}}</a>
        <a *ngIf="!getEventStream(liveSchedule)" class="title">{{liveSchedule.title}}</a>

        <div class="date" *ngIf="!getEventStream(liveSchedule)">
          <span>{{liveSchedule.day}} {{liveSchedule.air_time_unix * 1000 | date : 'h:mm a' : timezone}}
            {{timezoneString}}</span>
        </div>

        <div class="tags">
          <div class="badges" *ngIf="liveSchedule.is_premium || getEventStream(liveSchedule)">
            <ng-container *ngIf="liveSchedule.is_premium">
              <tyt-plus-tag *ngIf="isMember"></tyt-plus-tag>
              <tyt-plus-locked *ngIf="!isMember"></tyt-plus-locked>
            </ng-container>
            <a class="live-btn-container" *ngIf="getEventStream(liveSchedule)"
              routerLink="/live/streams/{{getEventStream(liveSchedule).id}}">
              <tyt-live-tag></tyt-live-tag>
            </a>
          </div>
        </div>
      </div>
    </li>
  </ul>

  <div class="more-link">
    <a routerLink="/live/schedule">Full Schedule</a>
  </div>

</div>